module.exports = __webpack_public_path__ + "static/media/captchaBG.edbfa1ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/kmcAssets/img/captchaBG.jpg
// module id = 2117
// module chunks = 1137